window.TimeKeepingAlertsAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['TimeKeepingAlertsServers']);

    self.ALERTS = {};
    self.ALERTS.EARLY_CLOCK_IN = "EARLY_CLOCK_IN";
    self.ALERTS.EARLY_CLOCK_OUT = "EARLY_CLOCK_OUT";
    self.ALERTS.LATE_CLOCK_IN = "LATE_CLOCK_IN";
    self.ALERTS.LATE_CLOCK_OUT = "LATE_CLOCK_OUT";
    self.ALERTS.LATE_CLOCK_IN_REMINDER = "LATE_CLOCK_IN_REMINDER";
    self.ALERTS.CLOCK_OUT_REMINDER = "CLOCK_OUT_REMINDER";
    self.ALERTS.CLOCK_OUT = "CLOCK_OUT";
    self.ALERTS.UNSCHEDULED_CLOCK_IN = "UNSCHEDULED_CLOCK_IN";
    self.ALERTS.MISSED_CLOCK_IN = "MISSED_CLOCK_IN";
    self.ALERTS.MISSED_CLOCK_OUT = "MISSED_CLOCK_OUT";
    self.ALERTS.MISSED_CLOCK_OUT_OT_NOW = "MISSED_CLOCK_OUT_OT_NOW";
    self.ALERTS.MISSED_SHIFT_IN_LOA = "MISSED_SHIFT_IN_LOA";
    self.ALERTS.EARLY_CLOCK_IN_REMINDER = "EARLY_CLOCK_IN_REMINDER";

    self.ALERTS_NAMES = {};
    self.ALERTS_NAMES.EARLY_CLOCK_IN = "early clock in";
    self.ALERTS_NAMES.EARLY_CLOCK_OUT = "early clock out";
    self.ALERTS_NAMES.LATE_CLOCK_IN = "late clock in";
    self.ALERTS_NAMES.LATE_CLOCK_OUT = "late clock out";
    self.ALERTS_NAMES.LATE_CLOCK_IN_REMINDER = "late clock in reminder";
    self.ALERTS_NAMES.CLOCK_OUT_REMINDER = "clock out reminder";
    self.ALERTS_NAMES.CLOCK_OUT = "clock out";
    self.ALERTS_NAMES.UNSCHEDULED_CLOCK_IN = "unscheduled clock in";
    self.ALERTS_NAMES.MISSED_CLOCK_IN = "missed clock in";
    self.ALERTS_NAMES.MISSED_CLOCK_OUT = "missed clock out";
    self.ALERTS_NAMES.MISSED_CLOCK_OUT_OT_NOW = "Unscheduled O.T";
    self.ALERTS_NAMES.MISSED_SHIFT_IN_LOA = "LOA Missed Clocks";
    self.ALERTS_NAMES.EARLY_CLOCK_IN_REMINDER = "early clock in reminder";

    self.getBrandAlerts = function(brandId, date) {
        var deferred = $q.defer();

        var params = {};
        params.day = date;
        _protected.request('brands/' + brandId + '/alerts', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getGroupAlerts = function(brandId, date){
        var deferred = $q.defer();

        var params = {};
        params.day = date;
        _protected.request('groups/' + brandId + '/alerts/stats', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandRemindersSettings = function(brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/reminders', 'GET').then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data.reminders);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateBrandRemindersSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/reminders', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    /* brand SMS settings */
    self.getBrandSMSSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/sms', 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateBrandSMSSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/sms', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getAlertsStats = function(brandId, date, alertType){
        var deferred = $q.defer();

        var params = {
            day: date,
            alert_types: alertType
        };

        _protected.request('brands/' + brandId + '/alerts/users/stats', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandConsentNotificationSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/consent/notification', 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data.notifications);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateBrandConsentNotificationSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/consent/notification', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getLiveBusinessShiftAlerts = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/live_shift_alert/business/settings', 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateBusinessLiveShiftAlerts = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/live_shift_alert/business/settings', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getLocationLiveShiftAlerts = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/live_shift_alert', 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateLocationLiveShiftAlerts = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/live_shift_alert', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

});
